import { render, staticRenderFns } from "./HomeCountBox.vue?vue&type=template&id=f808e576&scoped=true&lang=pug"
import script from "./HomeCountBox.vue?vue&type=script&lang=ts"
export * from "./HomeCountBox.vue?vue&type=script&lang=ts"
import style0 from "./HomeCountBox.vue?vue&type=style&index=0&id=f808e576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f808e576",
  null
  
)

export default component.exports